import React, { Component} from 'react';
import Form from 'react-bootstrap/Form';
import 'toastr/build/toastr.min.css';
import { DisplayMessage } from '../../../../services/helpers.js';
import DelayedRedirect from '../../../../utils/DelayedRedirect';
import { Transition } from '../../../../utils/ModalHelpers';
import { Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import ModifiedByInfo from "./../../../Common/Footers/ModifiedByInfo";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { SelectTheme } from '../../../../utils/utils.js';
import { ThemeProvider } from "@material-ui/core";
import appFetch from '../../../../api/appFetch.js';
import { WheelLocationsUrl, WheelLocationsWithIdUrl } from '../../../../constants/apiUrls.js';
import { externalPartyIdentifiers } from '../../../../constants/externalPartyIdentifiers.js';
import EnhancedDropdownComponent from "../../../Common/Dropdowns/EnhancedDropdownComponent";
import OutletsDropdown from '../../../Common/Dropdowns/OutletsDropdown.js';

export default class WheelLocationCreation extends Component {
    constructor(props) {
        super(props);
        let editedWheelLocation = undefined;
        let wheelLocationId = 0;
        let id = 0;
        let serviceSupplier = externalPartyIdentifiers.INTERNAL;

         if (this.props.location !== undefined && this.props.location.state !== undefined) {
          editedWheelLocation = this.props.editedWheelLocation;
            wheelLocationId = this.props.wheelLocationId;
            id = parseInt(this.props.wheelLocationId);
          }
           else if (this.props !== undefined) {
    
              if (this.props.wheelLocationId !== undefined) id = parseInt(this.props.wheelLocationId);
            }

        this.state = {
            id: id,
            serviceSupplier: serviceSupplier,
            description: "",
            subDescription: "",
            token: "",
            outletId: 0,
            isChangeLocation: false,
            isStorageLocation: false,

            modifiedByAvatar: "",
            modifiedByName: "",
            modifiedOn: "",

            editedWheelLocation: editedWheelLocation,
            wheelLocationId: wheelLocationId,

            loading: this.props.wheelLocationId !== undefined,
            redirect: false,
            requestInProgress: false,
            redirect: null,
            open: true,

            wheelLocationWasCreated: false,
        };
    }

    componentDidMount() {
        if (this.props !== undefined && this.props.editedWheelLocation !== undefined) {
            this.getEditedWheelLocationDetails(this.props.editedWheelLocation);
        } else if (this.state.id != undefined && this.state.id > 0) {
            this.getWheelLocationDetails();
        }
    }

    handleClose = () => {
        this.setState({ open: false, redirect: "/wheellocations" });
    };

    handleChange = e => {
        this.setState({ [e.target.name]: e.target.value.replace(/^\s+/, ""), isSaveButtonDisabled: !this.isValidForm(), requestInProgress: false });

    };

    handleServiceSuplierChange = e => {
        this.setState({ serviceSupplier : e.target.value, isSaveButtonDisabled: !this.isValidForm(), requestInProgress: false });

    };

    handleChangeCheckBox = e => {
        this.setState({ [e.target.name]: e.target.checked, requestInProgress: false });
    };


    handleKeyUp = e => {
        this.setState({ [e.target.name]: e.target.value })
    };


    isValidForm = () => {
        const { description, token, serviceSupplier } = this.state;

        if (!serviceSupplier || serviceSupplier === "") {
            return false;
        }


        if (!description || description.trim().length === 0) {
            return false;
        }


        if (serviceSupplier === externalPartyIdentifiers.DBB) {
            if (!token || token.trim().length !== 36) {
                return false;
            }
        }

        if (serviceSupplier === externalPartyIdentifiers.TEMUR) {
            if (!token || token.trim().length === 0) {
                return false;
            }
        }

        return true;
    }

    handleSaveWheelLocation = () => {
        if (this.state.id == 0) {
            this.saveNewwheelLocation();
        }
        else {
            this.saveEditedWheelLocation();
        }
    }

    saveNewwheelLocation = () => {
        let resources = this.props.resources;

        if (!this.isValidForm()) {
            return;
        }

        this.setState({ requestInProgress: true });

        var json = JSON.stringify({
            externalPartyIdentifier: this.state.serviceSupplier,
            description: this.state.description,
            locationToken: this.state.token !== "" ? this.state.token : null,
            descriptionSubLocation: this.state.subDescription !== "" ? this.state.subDescription : null,
            isChangeLocation: this.state.isChangeLocation,
            isStorageLocation: this.state.isStorageLocation,
            changeLocationOutletId: this.state.outletId !== 0 ? this.state.outletId : null
        });

        appFetch({
            url: WheelLocationsUrl(),
            method: 'POST',
            body: json,
            onSuccess: (data) => {
                DisplayMessage(resources["NewWheelLocationWasSaved"], "success");
                this.setState({ wheelLocationWasCreated: true, redirect: "/wheelLocations" });
            },
            onError: (data) => {
                for (let i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    saveEditedWheelLocation = () => {
        let resources = this.props.resources;

        if (!this.isValidForm()) {
            return;
        }

        this.setState({ requestInProgress: true });
        
        var data = {
              description: this.state.description,
              isChangeLocation: this.state.isChangeLocation,
              isStorageLocation: this.state.isStorageLocation,
              changeLocationOutletId: this.state.outletId !== 0 ? this.state.outletId : null,
        };

        if (this.state.token !== "")  {
            data.locationToken = this.state.token;
        }

        if (this.state.subDescription !== "")  {
            data.descriptionSubLocation = this.state.subDescription;
        }
        
        var json = JSON.stringify(data);

        appFetch({
            url: WheelLocationsWithIdUrl(this.state.id),
            method: 'PATCH',
            body: json,
            onSuccess: (data) => {
                DisplayMessage(resources["WheelLocationEditedSuccessfully"], "success");
                this.setState({ wheelLocationWasCreated: true, redirect: "/wheelLocations" });
            },
            onError: (data) => {
                for (let i = 0; i < data.errors.length; i++) {
                    DisplayMessage(data.errors[i], "error");
                }
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    getWheelLocationDetails = () => {
        const { id } = this.state;
        this.setState({ requestInProgress: true });

        let url = WheelLocationsUrl();

        appFetch({
            url: url,
            onSuccess: (data) => {
                var existsWheelLocation = false;
                var editedWheelLocation = undefined;

                data.forEach(function (row) {

                    if (row.id === id) {
                        existsWheelLocation = true;
                        editedWheelLocation = row;
                    }
                });

                if (existsWheelLocation) {
                    this.setState({
                        id: editedWheelLocation.id,
                        serviceSupplier: editedWheelLocation.externalPartyIdentifier,
                        description: editedWheelLocation.description,
                        subDescription: editedWheelLocation.descriptionSubLocation,
                        token: editedWheelLocation.locationToken,
                        isChangeLocation: editedWheelLocation.isChangeLocation,
                        isStorageLocation: editedWheelLocation.isStorageLocation,
                        modifiedOn: editedWheelLocation.modifiedOn,
                        modifiedByAvatar: editedWheelLocation.modifiedByAvatar,
                        modifiedByName: editedWheelLocation.modifiedByName,
                        requestInProgress: true,
                        outletId: editedWheelLocation.changeLocationOutletId,
                        loading: false
                    });
                } else {
                    this.setState({ open: false, redirect: "/wheellocations" });
                }
            },
            onError: (data) => {
            },
            onFinalize: () => {
                this.setState({ requestInProgress: false });
            }
        })
    }

    getEditedWheelLocationDetails = (editedWheelLocation) => {
        this.setState({
            id: editedWheelLocation.id,
            serviceSupplier: editedWheelLocation.externalPartyIdentifier,
            description: editedWheelLocation.description,
            subDescription: editedWheelLocation.descriptionSubLocation,
            token: editedWheelLocation.locationToken,
            isChangeLocation: editedWheelLocation.isChangeLocation,
            isStorageLocation: editedWheelLocation.isStorageLocation,
            modifiedOn: editedWheelLocation.modifiedOn,
            modifiedByAvatar: editedWheelLocation.modifiedByAvatar,
            modifiedByName: editedWheelLocation.modifiedByName,
            outletId: editedWheelLocation.changeLocationOutletId,
            requestInProgress: true,
            loading: false
        });
    }

    handleChangeOutlet = (v) => {
        this.setState({
            ...this.state,
            outletId: v.target.value
        })
    }

    handleSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.handleSaveWheelLocation();
    };

    renderExternalPartyIdentifiersDropdown = () => {
        var serviceSupplierValues = [
            { name: externalPartyIdentifiers.INTERNAL, value: externalPartyIdentifiers.INTERNAL },
            { name: externalPartyIdentifiers.DBB, value: externalPartyIdentifiers.DBB },
            { name: externalPartyIdentifiers.TEMUR, value: externalPartyIdentifiers.TEMUR },
        ];

        return serviceSupplierValues.map((serviceSupplier) => ({
            key: serviceSupplier.name,
            name: serviceSupplier.value,
        }))
    };


    renderModifiedByInfo = () => {
        if (this.state.id > 0) {
            return (
                <ModifiedByInfo
                    resources={this.props.resources}
                    modifiedByAvatar={this.state.modifiedByAvatar}
                    modifiedOn={this.state.modifiedOn}
                    modifiedByName={this.state.modifiedByName}
                    className="mt-3"
                />
            );
        }

        return;
    }

    renderForm() {
        const { description, subDescription, token, outletId, isChangeLocation, isStorageLocation, serviceSupplier } = this.state;

        var resources = this.props.resources;
        var helperTextDescription = description.trim().length <= 0 ? "helper-text-red" : "helper-text-grey";
        var isTokenInvalid = (serviceSupplier === externalPartyIdentifiers.DBB && (token === null || token.trim().length !== 36))
            || (serviceSupplier === externalPartyIdentifiers.TEMUR && (token === null || token.trim().length === 0));
        var helperTextToken = isTokenInvalid ? "helper-text-red" : "helper-text-grey";
        var disabled = this.state.id > 0;

        return (
            <div>
                <Paper elevation={3} className="p-4 mt-3 mb-3">
                    <Form onSubmit={this.handleSubmit} >
                        <div className="d-flex">
                            <div className="col-3"></div>
                                 <EnhancedDropdownComponent style={{textAlign: "left"}}
                                    id="service-suppliers-dropdown"
                                    value={serviceSupplier} 
                                    disabled={disabled} 
                                    labelText={resources["ServiceSupplier"]} 
                                    onChange={this.handleServiceSuplierChange}   
                                    options={this.renderExternalPartyIdentifiersDropdown()} >
                                    </EnhancedDropdownComponent>     
                            <div className="col-3"></div>
                        </div>

                        <Form.Group className="d-flex">
                            <div className="col-3"></div>
                            <ThemeProvider theme={SelectTheme}>
                                <TextField className={"col-6 " + helperTextDescription} id="wheel-location-description" label={resources["Description"]}
                                    value={description} helperText ={resources["InputOfDescriptionIsMandatory"]}
                                    variant="outlined" name="description" onChange={this.handleChange} onKeyUp={this.handleKeyUp} inputProps={{ maxLength: 256 }} />
                            </ThemeProvider >
                        </Form.Group>

                        <Form.Group className="d-flex">
                            <div className="col-3"></div>
                            <ThemeProvider theme={SelectTheme}>
                                <TextField className={"col-6 " + helperTextDescription} id="wheel-location-sub-description" label={resources["DescriptionSubLocation"]}
                                    value={subDescription}
                                    variant="outlined" name="subDescription" onChange={this.handleChange} onKeyUp={this.handleKeyUp} inputProps={{ maxLength: 256 }} />
                            </ThemeProvider >
                        </Form.Group>

                        <Form.Group className="d-flex">
                            <div className="col-3"></div>
                            <ThemeProvider theme={SelectTheme}>
                                <TextField className={"col-6 " + helperTextToken} id="wheel-location-token" label={resources["Token"]}
                                    value={token} helperText={
                                        serviceSupplier === externalPartyIdentifiers.DBB ? resources["InputOfTokenIsMandatoryAndMustHave36Characters"]
                                        : serviceSupplier === externalPartyIdentifiers.TEMUR ? resources["InputOfTokenIsMandatory"]
                                        : ""
                                    }
                                    variant="outlined" name="token" onChange={this.handleChange} onKeyUp={this.handleKeyUp} inputProps={{ maxLength: 64 }} />
                            </ThemeProvider >
                        </Form.Group>

                        <Form.Group className="d-flex">
                            <div className="col-3"></div>
                            <OutletsDropdown
                                resources={resources}
                                outlets={this.props.accessibleMoboOutlets}
                                outlet={outletId}
                                onOutletChange={this.handleChangeOutlet}
                                containerClass="col-6 helper-text-red"
                                disabled={!isChangeLocation}
                                defaultValue={`${resources["Select"]}...`}
                            />
                    </Form.Group>


                        <Form.Group style={{ display: "flex" }} >
                            <div className="col-md-3 "> </div>
                            <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                                control={<Checkbox id="wheel-location-is-change-location" checked={isChangeLocation} onChange={this.handleChangeCheckBox} name="isChangeLocation" color="primary" />}
                                label={resources["IsChangeLocation"]} />
                            <div className="col-md-4"> </div>
                        </Form.Group>

                        <Form.Group style={{ display: "flex" }} >
                            <div className="col-md-3 "> </div>
                            <FormControlLabel className="col-md-6 text-right label-mt my-auto p-0"
                                control={<Checkbox id="wheel-location-is-storage-location" checked={isStorageLocation} onChange={this.handleChangeCheckBox} name="isStorageLocation" color="primary" />}
                                label={resources["IsStorageLocation"]} />
                            <div className="col-md-4"> </div>
                        </Form.Group>
                        {this.renderModifiedByInfo()}
                    </Form>
                </Paper>
            </div >
        );
    }

    renderMain() {
        const { loading } = this.state;

        if (loading) {
            return (<div className="centered-loader"><CircularProgress /></div>);
        }

        return <div className={"py-4 grey " + (this.state.loading ? 'fadeOut' : 'fadeIn')}>
            {this.renderForm()}
        </div>;
    }

    render() {
        const { redirect, open, wheelLocationWasCreated, id, requestInProgress } = this.state;
        const { resources } = this.props;

        const isSaveButtonDisabled = requestInProgress || !this.isValidForm() || redirect;

        return (
            <div>
                {redirect && <DelayedRedirect to={{ pathname: redirect, state: { refreshGrid: wheelLocationWasCreated } }} delay={250} />}
                <Dialog fullScreen open={open} onClose={this.handleClose} TransitionComponent={Transition}>
                    <AppBar className="position-sticky ">
                        <Toolbar>
                            <IconButton id="close-add-wheelLocation" edge="start" color="inherit" onClick={this.handleClose} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" style={{ flex: 1 }}>
                                {id != undefined && id > 0 ? resources["EditWheelLocationTitle"] : resources["AddNewWheelLocationTitle"]}
                            </Typography>
                            <Button id="wheelLocation-save" color="inherit" disabled={isSaveButtonDisabled} onClick={this.handleSaveWheelLocation}>{resources["Save"]}</Button>
                        </Toolbar>
                    </AppBar>
                    <div className="container">
                        {this.renderMain()}
                    </div>
                </Dialog>
            </div >
        );
    }
}